export const appMenus = [
    {
        title: "Management Requests",
        icon: "/media/svg/icons/Files/Selected-file.svg",
        page: "/transfers",
        tab: "tabTransfers",
        permission: "",
        section: [
            {
                //Dashboard
                title: "Dashboard",
                permission: "accessToSettingsRead",
                submenu: [
                    {
                        title: "Dashboard",
                        icon: "/media/svg/icons/Home/Flower1.svg",
                        page: "/dashboard",
                        permission: "accessToSettingsRead",
                    },
                ],
            },
            {
                title: "Manage Content",
                permission: "accessToSettingsRead",
                submenu: [
                    {
                        title: "Events",
                        icon: "/media/svg/icons/General/Unlock.svg",
                        page: "/event-management/events",
                        permission: "accessToSettingsRead",
                    },
                    {
                        title: "Young Professionals",
                        icon: "/media/svg/icons/General/Scale.svg",
                        page: "/professional-management/professionals",
                        permission: "accessToSettingsRead",
                    },
                ],
            },
            {
                title: "Reports",
                permission: "accessToReportsAdminRead",
                submenu: [
                    {
                        title: "Users",
                        icon: "/media/svg/icons/Files/Folder-cloud.svg",
                        page: "/reports/users",
                        permission: "accessToReportsAdminRead",
                    },
                ],
            },
        ],
    },
    {
        title: "User Management",
        icon: "/media/svg/icons/Communication/Group.svg",
        page: "/user-management",
        tab: "tabUsers",
        permission: "accessToUsersRead",
        section: [
            {
                title: "User Management",
                permission: "accessToUsersRead",
                submenu: [
                    {
                        title: "Manage Users",
                        icon: "/media/svg/icons/Communication/Group.svg",
                        page: "/user-management/users",
                        permission: "accessToUsersRead",
                    },
                    {
                        title: "Manage Roles",
                        icon: "/media/svg/icons/Code/Compiling.svg",
                        page: "/user-management/roles",
                        permission: "accessToRolesRead",
                    },
                ],
            },
        ],
    },
    {
        title: "Settings",
        icon: "/media/svg/icons/General/Settings-1.svg",
        page: "/settings",
        tab: "tabSettings",
        permission: "accessToSettingsRead",
        section : [
            {
                title: "Settings",
                permission: "accessToSettingsRead",
                submenu: [
                    {
                        title: "View Settings",
                        icon: "/media/svg/icons/General/Settings-1.svg",
                        page: "/settings/view",
                        permission: "accessToSettingsRead",
                    },
                    {
                        title: "Update Settings",
                        icon: "/media/svg/icons/General/Settings-1.svg",
                        page: "/settings/update",
                        permission: "accessToSettingsRead",
                    },
                ],
            },
        ],
    }
];